module.exports = __webpack_public_path__ + "img/11.f0353c1f.png";